import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'

import { useConvertSurvey } from '../hooks/useConvertSurvey'
import { useSubmitAnswers } from '../hooks/useSubmitAnswers'
import 'survey-core/i18n/traditional-chinese'

const Agree = ({
  setAc,
  setTk,
  ac,
  tk,
  pid,
  setIsLoading,
  setCompletionMessage,
  serial_num,
}) => {
  const [myAgreeJson, setMyAgreeJson] = useState(null)
  // 需要登入嗎
  const requiresLogin = {
    login: false,
    title: '員工編號（邁達特：MA、啟迪：GI、聚上雲：EP、逐鹿：GU）',
    placeholder: 'MA00000',
    alert: '員工編號有誤，請重新登入，謝謝',
  }
  const [imagesReadingTime, setImagesReadingTime] = useState(0)
  const canShowPrevButtonPages = null
  const choicesOrderRef = useRef({})
  const choiceIndexMapRef = useRef({})
  const bringOptionsMapRef = useRef({})
  // 防止閃閃
  useEffect(() => {
    const timeout = setTimeout(() => {
      const isMobile = window.innerWidth <= 576
      if (!isMobile) return

      const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            const rootEl = document.querySelector('.sd-root-modern')
            if (
              rootEl &&
              !rootEl.classList.contains('sd-root-modern--mobile')
            ) {
              rootEl.classList.add('sd-root-modern--mobile')
              console.log('✅ 強制加上 mobile class 避免抖動')
            }
          }
        }
      })

      observer.observe(document.getElementById('root'), {
        childList: true,
        subtree: true,
      })

      // 清除
      return () => observer.disconnect()
    }, 100) // 100ms 後再判斷

    return () => clearTimeout(timeout)
  }, [])
  // 圖片閱讀時間(秒)
  // useEffect(() => {
  //   setImagesReadingTime(30)
  // }, [])
  const completedHtml = `<h3>問卷正在提交中，請稍候。</h3><h3>請在成功頁面顯示後再離開。</h3><h4>如有填卷相關問題請洽：</h4> <a href='https://lin.ee/HWETcqy'>https://lin.ee/HWETcqy</a><h4 style='margin-top:50px'>填寫其他問卷：</h4> <a href=${window.location.origin}>${window.location.origin}</a>`

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const agreeSurvey = new Model(myAgreeJson)

  // 問卷編號
  // const pid = pid
  // 跳題 小心複選題要用陣列

  // const visibleIfConditionsInit = {
  //   q6: '{q5} = 0 or {q5} = 1 or {q5} = 2 or {q5} = 3',
  //   q7: '{q6} = ["none"]',
  //   q36: `{q35} <> ['none']`,
  // }

  // 戶籍地跟居住地不一樣
  const addressMismatch = '{q23} = 0 and '

  const visibleIfConditionsInit = {
    q1: '{q0} = 0',
    q2: '{q0} = 1',
    q3: '{q0} = 2',
    q4: '{q0} = 3',
    q5: '{q0} = 4',
    q6: '{q0} = 5',
    q7: '{q0} = 6',
    q8: '{q0} = 7',
    q9: '{q0} = 8',
    q10: '{q0} = 9',
    q11: '{q0} = 10',
    q12: '{q0} = 11',
    q13: '{q0} = 12',
    q14: '{q0} = 13',
    q15: '{q0} = 14',
    q16: '{q0} = 15',
    q17: '{q0} = 16',
    q18: '{q0} = 17',
    q19: '{q0} = 18',
    q20: '{q0} = 19',
    q21: '{q0} = 20',
    q22: '{q0} = 21',
    // 請問您的戶籍地與居住地是否一樣？
    q24: '{q23} = 0',

    q25: addressMismatch + '{q24} = 0',
    q26: addressMismatch + '{q24} = 1',
    q27: addressMismatch + '{q24} = 2',
    q28: addressMismatch + '{q24} = 3',
    q29: addressMismatch + '{q24} = 4',
    q30: addressMismatch + '{q24} = 5',
    q31: addressMismatch + '{q24} = 6',
    q32: addressMismatch + '{q24} = 7',
    q33: addressMismatch + '{q24} = 8',
    q34: addressMismatch + '{q24} = 9',
    q35: addressMismatch + '{q24} = 10',
    q36: addressMismatch + '{q24} = 11',
    q37: addressMismatch + '{q24} = 12',
    q38: addressMismatch + '{q24} = 13',
    q39: addressMismatch + '{q24} = 14',
    q40: addressMismatch + '{q24} = 15',
    q41: addressMismatch + '{q24} = 16',
    q42: addressMismatch + '{q24} = 17',
    q43: addressMismatch + '{q24} = 18',
    q44: addressMismatch + '{q24} = 19',
    q45: addressMismatch + '{q24} = 20',
    q46: addressMismatch + '{q24} = 21',

    q58: '{q57} anyof [6]',

    q62: '{q23} = 0',
    q63: '{q23} = 0',

    q68: '{q67} = 3 or {q67} = 4',
    q105: '{q104} = 7',
  }
  // const visibleIfConditionsInit = null
  // const pageVisibleIfConditionsInit = null

  // 非必填(從 0 計算)
  // const notRequired = [100]
  const notRequired = null

  const mappedRateChoice = null
  // const pageBreakQuestions = ['q6', 'q11', 'q15']
  const pageBreakQuestions = null

  const triggersConditionsInit = [
    // {
    //   type: 'complete',
    //   expression: `({q0} = 1) or ({q1} = 1) or ({q2} = 0 or {q2} = 1)`,
    // },
  ]
  // const triggersConditionsInit = null
  // const pageVisibleIfConditionsInit = null
  // 帶出: 帶入
  const questionMappings = {
    // q20: 'q21',
  }

  const convertedSurvey = useConvertSurvey({
    survey: agreeSurvey,
    pid,
    setAc,
    setTk,
    ac,
    tk,
    setMyAgreeJson,
    imagesReadingTime,
    setImagesReadingTime,
    setIsLoading,
    completedHtml,
    visibleIfConditionsInit,
    notRequired,
    mappedRateChoice,
    pageBreakQuestions,
    requiresLogin,
    triggersConditionsInit,
    questionMappings,
    bringOptionsMapRef,
    serial_num,
  })

  // const newSurvey = new Model(convertedSurvey)

  const surveyModel = useMemo(() => {
    if (!convertedSurvey) return null
    return new Model(convertedSurvey)
  }, [convertedSurvey])

  // useEffect(() => {
  //   console.log('convertedSurvey', convertedSurvey)
  // }, [convertedSurvey])

  const endMessage = `目前與您相同特性的樣本額滿，已停止收卷，可惜沒辦法繼續參與本次活動。如果覺得這個主題很有意思，非常歡迎您分享本問卷連結給親友，或是加入我們的<a href='https://lin.ee/HWETcqy'>LINE@</a>，隨時得到最新填問卷獲好禮的消息。<p>請按「完成」前往下載 EZChoice 或填寫更多問卷</p>`

  function helpFunction(survey, options) {
    // console.log('survey.getValue(q42)', survey.getValue('q42'))
    // 參考 P231113152849 或 P231101165555 或 P231206105643(政大帶入選項)
  }

  const endSurveyMsg = (survey) => {
    // if (
    //   survey.getValue('q0') === 1 ||
    //   survey.getValue('q1') === 1 ||
    //   survey.getValue('q2') === 0 ||
    //   survey.getValue('q2') === 1
    // ) {
    //   setCompletionMessage(endMessage)
    // } else {
    setCompletionMessage(
      `<div>非常感謝您抽空填寫問卷，您的寶貴意見將提供政府制定高放處置設施選址法制及相關社會溝通策略之參考。<br><br>若您對本問卷有任何問題或建議，歡迎隨時與研究團隊聯繫。<br><br>公告網址查詢：<br>一、政治大學永續創新民主研究中心官網公告（最新消息區-&gt;11/10公告）<br><a href="https://cid.nccu.edu.tw/public-opinion-survey-2025/" target="_blank">https://cid.nccu.edu.tw/public-opinion-survey-2025/</a><br><br>二、核廢專案辦公室網站公告（最新消息區-&gt;11/10公告）<br><a href="https://nwp.tw/blog/articles/6773" target="_blank">https://nwp.tw/blog/articles/6773</a><br><br><b>執行單位 典通股份有限公司 聯絡電話：02-23315133 #601-604</b><br><b>委託單位 政治大學永續創新民主研究中心 聯絡電話：02-29393091 #69308</b><br><br>政治大學永續創新民主研究中心 敬上</div>`
    )
    // }
  }

  // useEffect(() => {
  //   console.log('bringOptionsMapRef', bringOptionsMapRef)
  // }, [bringOptionsMapRef])

  useSubmitAnswers({
    survey: surveyModel,
    pid,
    ac,
    tk,
    imagesReadingTime,
    setIsLoading,
    helpFunction,
    canShowPrevButtonPages,
    choicesOrderRef,
    choiceIndexMapRef,
    endSurveyMsg,
    bringOptionsMapRef,
  })

  return (
    <>
      {surveyModel ? (
        <Survey model={surveyModel} key={pid} />
      ) : myAgreeJson ? (
        <Survey model={agreeSurvey} />
      ) : (
        <></>
      )}
    </>
  )
}

export default Agree
